import type { AuthSession } from './types';

export function unwrapAuthSession(response: unknown): AuthSession {
  if (!response || typeof response !== 'object') {
    return {};
  }

  const envelope = response as { data?: AuthSession };
  if (envelope.data && typeof envelope.data === 'object') {
    return envelope.data;
  }

  return response as AuthSession;
}
